import React from 'react'
import {   Field} from 'redux-form'

export class SVDropdown extends React.Component{
    

    constructor(props){
        super(props)


    }
  
    svDDChange(e){
        //this.refs.DropdownList.refs
        //this.refs.DropdownList.refs.inner.handleClick()
        console.log(e)
        console.log('got'+ e.target.value)
        

/*
        //ob.target.value
        if(e.target.value =='string'){
            console.log('sv change action to change class')
           // this.props.initialValues.gene
            this.svfieldType= 'CL_String'
        }else if(e.target.value == 'date'){
            this.svfieldType= 'CL_Date'
        }else if(e.target.value == 'narray'){
            this.svfieldType= 'CL_NArray'    

        }else{
            this.svfieldType= 'CL_Number'
        }

        this.setState({
            svfieldType:this.svfieldType
        })
*/
    }
    componentWillReceiveProps(next){
        console.log('props changed SVString')

    }
   

    render(){
        console.log('render SVNumber')
        console.log(this.props)

        let me = this

       let {name, placeholder, svtypes} = this.props
/*
        const {label,label_forName, input, type,
            meta:{
              touched, error, warning
            }
           } = this.props*/
          return (

        <div>
            <label>Select</label>
            <div>
            <Field 
              onChange={me.svDDChange}  component="select"  name={name}   
              className="form-control" >
                
            <option value="">Select   </option>
            {

        
                   svtypes.map(  (o, idx)=>(  <option value={o.value} key={o.key}>{o.key}</option>)
                
           
        )}

        </Field>
            </div>

        </div>
       

            
              
          )
          
       

    }
}